/* eslint-disable */
// src/services/faqConfigService.js

import {
    doc,
    getDoc,
    setDoc,
    serverTimestamp,
} from "firebase/firestore";
import { db } from "./firebase";

// FAQ 설정 컬렉션: ui_faq (draft / published 두 문서 사용)
const COL = "ui_faq";

/**
 * 드래프트 FAQ 가져오기 (관리자용)
 * 반환 형태: { sections: [...] } 또는 null
 */
export async function getFaqDraft() {
    const ref = doc(db, COL, "draft");
    const snap = await getDoc(ref);
    if (!snap.exists()) return null;
    const data = snap.data() || {};
    const sections = Array.isArray(data.sections) ? data.sections : [];
    return { sections };
}

/**
 * 발행된 FAQ 가져오기 (사용자용)
 * 반환 형태: { sections: [...] } 또는 null
 */
export async function getFaqPublished() {
    const ref = doc(db, COL, "published");
    const snap = await getDoc(ref);
    if (!snap.exists()) return null;
    const data = snap.data() || {};
    const sections = Array.isArray(data.sections) ? data.sections : [];
    return { sections };
}

/**
 * FAQ 드래프트 저장
 * sections: [{ title, items: [{ q, a }, ...] }, ...]
 */
export async function saveFaqDraft(sections, { uid = "admin" } = {}) {
    const ref = doc(db, COL, "draft");
    await setDoc(ref, {
        sections: sections || [],
        _meta: {
            updatedAt: serverTimestamp(),
            updatedBy: uid || "admin",
        },
    });
}

/**
 * FAQ 발행
 * - draft 문서를 읽어서 published 로 그대로 복사
 * - _meta.publishedAt / publishedBy 추가
 */
export async function publishFaq({ uid = "admin" } = {}) {
    const draftRef = doc(db, COL, "draft");
    const draftSnap = await getDoc(draftRef);
    if (!draftSnap.exists()) {
        throw new Error("FAQ draft 문서가 없습니다. 먼저 임시 저장해 주세요.");
    }

    const draftData = draftSnap.data() || {};
    const pubRef = doc(db, COL, "published");

    await setDoc(pubRef, {
        ...draftData,
        _meta: {
            ...(draftData._meta || {}),
            publishedAt: serverTimestamp(),
            publishedBy: uid || "admin",
        },
    });

    return true;
}
